import React from 'react';
import { InfoCardVariants, TableColumn } from '@backstage/core-components';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { ComponentEntity, Entity } from '@backstage/catalog-model';
import { RelatedEntitiesCard } from '../RelatedEntitiesCard/RelatedEntitiesCard';

export interface HasResourcesCardProps {
  variant?: InfoCardVariants;
}

export const HasResourcesCard = (props: HasResourcesCardProps) => {
  const { variant = 'gridItem' } = props;

  const resourceEntityColumns: TableColumn<ComponentEntity>[] = [
    EntityTable.columns.createEntityRefColumn({ defaultKind: 'resource' }),
    EntityTable.columns.createSpecTypeColumn(),
    EntityTable.columns.createSpecLifecycleColumn(),
    EntityTable.columns.createMetadataDescriptionColumn(),
  ];

  const asResourceEntities = (entities: Entity[]): ComponentEntity[] =>
    entities as ComponentEntity[];

  return (
    <RelatedEntitiesCard
      variant={variant}
      title="Resources"
      entityKind="Resource"
      columns={resourceEntityColumns}
      asRenderableEntities={asResourceEntities}
    />
  );
};
